"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Basic_1 = __importDefault(require("../../networking/apis/Basic"));
const scale_1 = require("../../utils/scale");
const ModalUnfollowUser_1 = __importDefault(require("../modal/ModalUnfollowUser"));
const CustomText_1 = __importDefault(require("../text/CustomText"));
const LinearButton_1 = __importDefault(require("./LinearButton"));
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const FollowButton = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { userId, nickname, defaultValue, customStyle = {}, onFollowUser, onUnfollowUser } = props;
    const [isFollowed, setFollowed] = (0, react_1.useState)(defaultValue);
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const isAnonymous = myProfile?.registration_status == 0;
    const handleFollowUser = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${nickname}さんをフォローしました`));
            setFollowed(true);
            onFollowUser?.();
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleUnfollowUser = () => {
        if (refIsCallingAPI.current || isAnonymous)
            return;
        refIsCallingAPI.current = true;
        setModalVisible(false);
        Basic_1.default.unfollowUser(userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${nickname}さんをフォロー解除しました`));
            setFollowed(false);
            onUnfollowUser?.();
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handlePress = (event) => {
        if (!isFollowed) {
            handleFollowUser();
        }
        else {
            const { pageY } = event.nativeEvent;
            setModalPosition({ x: (0, scale_1.scale)(293), y: pageY });
            setModalVisible(true);
        }
    };
    if (userId == myProfile?.user_id)
        return;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isFollowed ?
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: [styles.button, customStyle, { backgroundColor: '#DDDDDD' }], onPress: handlePress },
                react_1.default.createElement(CustomText_1.default, { style: styles.buttonLabel }, "\u30D5\u30A9\u30ED\u30FC\u4E2D"))
            :
                react_1.default.createElement(LinearButton_1.default, { title: "\u30D5\u30A9\u30ED\u30FC", textStyle: [styles.buttonLabel, { color: '#FEFEFE' }], style: [styles.button, customStyle], onPress: handleFollowUser }),
        react_1.default.createElement(ModalUnfollowUser_1.default, { data: { user_nickname: nickname }, onClose: () => setModalVisible(false), visible: modalVisible, modalPosition: modalPosition, onChange: handleUnfollowUser })));
};
const styles = react_native_1.StyleSheet.create({
    button: {
        width: (0, scale_1.scale)(96),
        height: (0, scale_1.scale)(32),
        justifyContent: "center",
        alignItems: "center",
        borderRadius: (0, scale_1.scale)(4),
    },
    buttonLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: "#545454",
    },
});
exports.default = FollowButton;
